import { _404_MY_BAZAAR_LAST_PRODUCT_NOT_FOUND, CTA_RETURN_BACK } from 'mk/autogenerated/translations/MyBazaarLastProductNotFound.94aa7a1ba3c06b0b54a1f8903eacf4ad'
import assetUrl from 'mk/common/assetUrl';
import { faqBazaarSellingTips } from 'mk2/apps/faq/urls';
import { BackBtn } from 'mk2/components/BackBtn';
import { BtnLayout, BtnType } from 'mk2/components/Btn';
import { Img } from 'mk2/components/Img';
import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router';
import styles from './MyBazaarLastProductNotFound.mscss';

type Props = RouteComponentProps<{}>;

export class MyBazaarLastProductNotFound extends React.Component<Props> {
    public render() {
        const title = _404_MY_BAZAAR_LAST_PRODUCT_NOT_FOUND;
        return (
            <div className={styles.NotFoundError}>
                <div className={styles.NotFoundError}>
                    <Helmet>
                        <title>{title}</title>
                        <meta property="og:title" content={title} />
                    </Helmet>
                    <div className={styles.NotFoundError__icon}>
                    <Img
                        className={styles.NotFoundError__icon__image}
                        src={assetUrl + 'img/miky/shrug-miky@2x.png'}
                        width={268}
                        height={271} />
                    </div>
                    <div className={styles.NotFoundError__message}>
                        {title}
                    </div>
                    <div className={styles.NotFoundError__button}>
                        <BackBtn
                            label={CTA_RETURN_BACK}
                            layout={BtnLayout.IconLabelCount}
                            link={faqBazaarSellingTips}
                            type={BtnType.Blue}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
